/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AllCombinationsDisabledExceptionDetails } from './AllCombinationsDisabledExceptionDetails';
import {
    instanceOfAllCombinationsDisabledExceptionDetails,
    AllCombinationsDisabledExceptionDetailsFromJSON,
    AllCombinationsDisabledExceptionDetailsFromJSONTyped,
    AllCombinationsDisabledExceptionDetailsToJSON,
} from './AllCombinationsDisabledExceptionDetails';
import type { DbConcurrencyExceptionDetails } from './DbConcurrencyExceptionDetails';
import {
    instanceOfDbConcurrencyExceptionDetails,
    DbConcurrencyExceptionDetailsFromJSON,
    DbConcurrencyExceptionDetailsFromJSONTyped,
    DbConcurrencyExceptionDetailsToJSON,
} from './DbConcurrencyExceptionDetails';
import type { IdentityExceptionDetails } from './IdentityExceptionDetails';
import {
    instanceOfIdentityExceptionDetails,
    IdentityExceptionDetailsFromJSON,
    IdentityExceptionDetailsFromJSONTyped,
    IdentityExceptionDetailsToJSON,
} from './IdentityExceptionDetails';
import type { MaintenanceModeExceptionDetails } from './MaintenanceModeExceptionDetails';
import {
    instanceOfMaintenanceModeExceptionDetails,
    MaintenanceModeExceptionDetailsFromJSON,
    MaintenanceModeExceptionDetailsFromJSONTyped,
    MaintenanceModeExceptionDetailsToJSON,
} from './MaintenanceModeExceptionDetails';
import type { PtwErrorExceptionDetails } from './PtwErrorExceptionDetails';
import {
    instanceOfPtwErrorExceptionDetails,
    PtwErrorExceptionDetailsFromJSON,
    PtwErrorExceptionDetailsFromJSONTyped,
    PtwErrorExceptionDetailsToJSON,
} from './PtwErrorExceptionDetails';
import type { TooManySetupCombinationsExceptionDetails } from './TooManySetupCombinationsExceptionDetails';
import {
    instanceOfTooManySetupCombinationsExceptionDetails,
    TooManySetupCombinationsExceptionDetailsFromJSON,
    TooManySetupCombinationsExceptionDetailsFromJSONTyped,
    TooManySetupCombinationsExceptionDetailsToJSON,
} from './TooManySetupCombinationsExceptionDetails';
import type { UserLockoutInfo } from './UserLockoutInfo';
import {
    instanceOfUserLockoutInfo,
    UserLockoutInfoFromJSON,
    UserLockoutInfoFromJSONTyped,
    UserLockoutInfoToJSON,
} from './UserLockoutInfo';
import type { UserLockoutInfoDto } from './UserLockoutInfoDto';
import {
    instanceOfUserLockoutInfoDto,
    UserLockoutInfoDtoFromJSON,
    UserLockoutInfoDtoFromJSONTyped,
    UserLockoutInfoDtoToJSON,
} from './UserLockoutInfoDto';

/**
 * @type ExceptionDetails
 * 
 * @export
 */
export type ExceptionDetails = { $type?: 'Ptw.Ptw100.AppZero.Application.Authorization.ApplicationServices.IdentityExceptionDetails, Ptw.Ptw100.AppZero.Application' } & IdentityExceptionDetails | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.UserLockoutInfoDto, Ptw.Ptw100.AppZero.Application.Shared' } & UserLockoutInfoDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Common.MaintenanceModeExceptionDetails, Ptw.Ptw100.AppZero.Application.Shared' } & MaintenanceModeExceptionDetails | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.PtwErrorExceptionDetails, Ptw.Ptw100.AppZero.Application.Shared' } & PtwErrorExceptionDetails | { $type?: 'Ptw.Ptw100.AppZero.Application.TaskItemComponent.AllCombinationsDisabledExceptionDetails, Ptw.Ptw100.AppZero.Application' } & AllCombinationsDisabledExceptionDetails | { $type?: 'Ptw.Ptw100.AppZero.Application.TaskItemComponent.TooManySetupCombinationsExceptionDetails, Ptw.Ptw100.AppZero.Application' } & TooManySetupCombinationsExceptionDetails | { $type?: 'Ptw.Ptw100.AppZero.Core.Authorization.Users.UserLockoutInfo, Ptw.Ptw100.AppZero.Core' } & UserLockoutInfo | { $type?: 'Ptw.Ptw100.Persistence.EntityFrameworkCore.DbConcurrencyExceptionDetails, Ptw.Ptw100.Persistence.EntityFrameworkCore' } & DbConcurrencyExceptionDetails;


export function ExceptionDetailsFromJSON(json: any): ExceptionDetails {
    return ExceptionDetailsFromJSONTyped(json, false);
}

export function ExceptionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExceptionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Authorization.ApplicationServices.IdentityExceptionDetails, Ptw.Ptw100.AppZero.Application':
            return {...IdentityExceptionDetailsFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Authorization.ApplicationServices.IdentityExceptionDetails, Ptw.Ptw100.AppZero.Application'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.UserLockoutInfoDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...UserLockoutInfoDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.UserLockoutInfoDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.Common.MaintenanceModeExceptionDetails, Ptw.Ptw100.AppZero.Application.Shared':
            return {...MaintenanceModeExceptionDetailsFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.Common.MaintenanceModeExceptionDetails, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.PtwErrorExceptionDetails, Ptw.Ptw100.AppZero.Application.Shared':
            return {...PtwErrorExceptionDetailsFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.PtwErrorExceptionDetails, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.TaskItemComponent.AllCombinationsDisabledExceptionDetails, Ptw.Ptw100.AppZero.Application':
            return {...AllCombinationsDisabledExceptionDetailsFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.TaskItemComponent.AllCombinationsDisabledExceptionDetails, Ptw.Ptw100.AppZero.Application'};
        case 'Ptw.Ptw100.AppZero.Application.TaskItemComponent.TooManySetupCombinationsExceptionDetails, Ptw.Ptw100.AppZero.Application':
            return {...TooManySetupCombinationsExceptionDetailsFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.TaskItemComponent.TooManySetupCombinationsExceptionDetails, Ptw.Ptw100.AppZero.Application'};
        case 'Ptw.Ptw100.AppZero.Core.Authorization.Users.UserLockoutInfo, Ptw.Ptw100.AppZero.Core':
            return {...UserLockoutInfoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Core.Authorization.Users.UserLockoutInfo, Ptw.Ptw100.AppZero.Core'};
        case 'Ptw.Ptw100.Persistence.EntityFrameworkCore.DbConcurrencyExceptionDetails, Ptw.Ptw100.Persistence.EntityFrameworkCore':
            return {...DbConcurrencyExceptionDetailsFromJSONTyped(json, true), $type: 'Ptw.Ptw100.Persistence.EntityFrameworkCore.DbConcurrencyExceptionDetails, Ptw.Ptw100.Persistence.EntityFrameworkCore'};
        default:
            throw new Error(`No variant of ExceptionDetails exists with '$type=${json['$type']}'`);
    }
}

export function ExceptionDetailsToJSON(value?: ExceptionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Authorization.ApplicationServices.IdentityExceptionDetails, Ptw.Ptw100.AppZero.Application':
            return IdentityExceptionDetailsToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.UserLockoutInfoDto, Ptw.Ptw100.AppZero.Application.Shared':
            return UserLockoutInfoDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Common.MaintenanceModeExceptionDetails, Ptw.Ptw100.AppZero.Application.Shared':
            return MaintenanceModeExceptionDetailsToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.PtwErrorExceptionDetails, Ptw.Ptw100.AppZero.Application.Shared':
            return PtwErrorExceptionDetailsToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.TaskItemComponent.AllCombinationsDisabledExceptionDetails, Ptw.Ptw100.AppZero.Application':
            return AllCombinationsDisabledExceptionDetailsToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.TaskItemComponent.TooManySetupCombinationsExceptionDetails, Ptw.Ptw100.AppZero.Application':
            return TooManySetupCombinationsExceptionDetailsToJSON(value);
        case 'Ptw.Ptw100.AppZero.Core.Authorization.Users.UserLockoutInfo, Ptw.Ptw100.AppZero.Core':
            return UserLockoutInfoToJSON(value);
        case 'Ptw.Ptw100.Persistence.EntityFrameworkCore.DbConcurrencyExceptionDetails, Ptw.Ptw100.Persistence.EntityFrameworkCore':
            return DbConcurrencyExceptionDetailsToJSON(value);
        default:
            throw new Error(`No variant of ExceptionDetails exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the ExceptionDetails interface.
 */
export function instanceOfExceptionDetails(value: any): value is ExceptionDetails {
    if (instanceOfIdentityExceptionDetails(value)) return true;
    if (instanceOfUserLockoutInfoDto(value)) return true;
    if (instanceOfMaintenanceModeExceptionDetails(value)) return true;
    if (instanceOfPtwErrorExceptionDetails(value)) return true;
    if (instanceOfAllCombinationsDisabledExceptionDetails(value)) return true;
    if (instanceOfTooManySetupCombinationsExceptionDetails(value)) return true;
    if (instanceOfUserLockoutInfo(value)) return true;
    if (instanceOfDbConcurrencyExceptionDetails(value)) return true;
    return false;
}

